import { Badge, BadgeProps } from '@/components/ui/badge'
import {
  EstateStatus,
  EstateWithApplicationsStatus,
  getEstateStatus,
} from '@/estate/utils/getEstateStatus'
import { TFunction } from 'i18next'
import React from 'react'
import { useTranslation } from 'react-i18next'

type ConfigEntry = BadgeProps & { label: string }

const getConfig = (t: TFunction) => ({
  [EstateStatus.Archived]: {
    label: t(`EstateStatusBadge.archived`),
    variant: 'destructive',
    className: 'tw-ml-2',
  } as ConfigEntry,
  [EstateStatus.InEdition]: {
    label: t(`EstateStatusBadge.inEdition`),
    variant: 'secondary',
  } as ConfigEntry,
  [EstateStatus.MandateSigned]: {
    label: t(`EstateStatusBadge.mandateSigned`),
  } as ConfigEntry,
  [EstateStatus.AOInProgress]: {
    label: t(`EstateStatusBadge.aoInProgress`),
  } as ConfigEntry,
  [EstateStatus.AODone]: {
    label: t(`EstateStatusBadge.aoDone`),
    variant: 'success',
  } as ConfigEntry,
  [EstateStatus.InNegociation]: {
    label: t(`EstateStatusBadge.inNegociation`),
    variant: 'success',
  } as ConfigEntry,
  [EstateStatus.UnderPromess]: {
    label: t(`EstateStatusBadge.underPromess`),
    variant: 'success',
  } as ConfigEntry,
  [EstateStatus.Sold]: {
    label: t(`EstateStatusBadge.sold`),
    variant: 'success',
  } as ConfigEntry,
})

type EstateStatusBadgeProps = {
  estate: EstateWithApplicationsStatus
}

export const EstateStatusBadge = ({ estate }: EstateStatusBadgeProps) => {
  const { t } = useTranslation()
  const config = getConfig(t)
  const key = getEstateStatus(estate)
  const { label, ...props } = config[key]

  return <Badge {...props}>{label}</Badge>
}
